// @flow
import React, { Fragment, useState } from 'react'
import ReactLoadScript from 'react-load-script'

type Props = {|
  source: string,
  render: Function
|}

export default function ScriptDependencyRender(props: Props) {
  const { render, source } = props
  const [isLoaded, setIsLoaded] = useState(false)

  return (
    <Fragment>
      <ReactLoadScript
        url={source}
        onLoad={() => {
          setIsLoaded(true)
        }}
        onError={() => {
          console.error(`Fail to load script: ${source}`)
        }}
      />
      {isLoaded && render()}
    </Fragment>
  )
}
